module.exports = __webpack_public_path__ + "static/media/options-cercle.08434c48.png";